import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AssumptionAdminOverride } from 'Overrides/AssumptionAdminOverride';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import AssumptionAdminLayout
  from './Content/AssumptionAdminLayout';

const FacetPlanAssumptionSetTemplate = ({
  className,
}) => {
  const { pageContentCollection } = usePageContentContext();
  return (
    <Box
      className={classNames(className)}
    >
      <MetaCollectionFormInline
        collection={pageContentCollection}
        metaOverrideSet={AssumptionAdminOverride}
        FormProps={{
          layout: AssumptionAdminLayout,
          noIndividualSubmitButtons: true,
        }}
      />
    </Box>
  );
};

FacetPlanAssumptionSetTemplate.defaultProps = {
  className: '',
};

FacetPlanAssumptionSetTemplate.propTypes = {
  className: PropTypes.string,
};

export default FacetPlanAssumptionSetTemplate;
